import React from 'react';
import PropTypes from 'prop-types';
import Creatable from 'react-select/creatable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import AssetTag from './AssetTag';
import { TAG_CREATE_EVENT } from '../../Constants/TrackerClasses';

const selectStyles = {
  dropdownIndicator: () => ({ display: 'none' }),
  indicatorSeparator: () => ({ display: 'none' }),
};

export default function AssetTagDisplay(props) {
  const {
    createTagRequestPending,
    nameSuggestions,
    deleteTagRequestPending,
    dropdownLoading,
    tagName,
    tagValue,
    handleSubmit,
    handleDelete,
    handleChange,
    handleNameInput,
    handleNameSelect,
    handleBlur,
    visibility,
    tags,
  } = props;
  return (
    <div className={visibility}>
      <div
        className={`d-flex justify-content-center inner-modal-container mh-75`}
      >
        <div className="row">
          <div className="col-12">
            <form onSubmit={handleSubmit}>
              <div className="row align-items-center">
                <div className="col-12 col-sm-5 d-flex">
                  <div className="form-group w-100">
                    <label
                      name="tagName"
                      htmlFor="tag-name-input"
                      className="text-muted form-labels modal-inputlabel-text"
                    >
                      Tag Name (i.e. Location)
                    </label>
                    <Creatable
                      styles={selectStyles}
                      className="align-baseline w-100"
                      name="tagName"
                      value={tagName}
                      id="tag-name-input"
                      options={nameSuggestions}
                      onInputChange={handleNameInput}
                      onChange={handleNameSelect}
                      isLoading={dropdownLoading}
                      onBlur={handleBlur}
                      placeholder={null}
                      isClearable
                      isSearchable
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-5 d-flex">
                  <div className="form-group w-100">
                    <label
                      name="tagValue"
                      htmlFor="tag-value-input"
                      className="text-muted form-labels modal-inputlabel-text"
                    >
                      Tag Value (i.e. Seattle)
                    </label>
                    <input
                      name="tagValue"
                      value={tagValue}
                      type="text"
                      id="tag-value-input"
                      className="form-control align-baseline"
                      aria-describedby="nameHelpBlock"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-2 d-flex align-items-center">
                  <button
                    name="addButton"
                    className={`btn modal-button-submit align-baseline text-nowrap ${TAG_CREATE_EVENT}`}
                    type="submit"
                    disabled={tags.length >= 20 || createTagRequestPending}
                  >
                    {createTagRequestPending ? (
                      <FontAwesomeIcon icon={faCircleNotch} spin size="lg" />
                    ) : (
                      '+'
                    )}
                  </button>
                </div>
              </div>
            </form>
            {tags.length >= 20 ? (
              <p className="text-info three-quarter-text mt-3 mt-md-0">
                You&#39;ve reached the maximum number of tags allowed per asset
              </p>
            ) : (
              <p className="text-muted three-quarter-text mt-3 mt-md-0">
                Add up to 20 tags for every asset
              </p>
            )}
            <div className="col-12 bg-background-gray px-0 w-100 overflow-auto tag-display-box">
              {tags.map((tag) => {
                return (
                  <span key={tag._id}>
                    <AssetTag
                      tagName={tag.name}
                      tagValue={tag.value}
                      tagID={tag._id}
                      deleteTagRequestPending={deleteTagRequestPending}
                      handleDelete={handleDelete}
                      hideDeleteButton={false}
                    />
                  </span>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .tag-display-box {
          border-radius: 6px;
          min-height: 200px;
        }
      `}</style>
    </div>
  );
}
AssetTagDisplay.propTypes = {
  handleChange: PropTypes.func,
  handleDelete: PropTypes.func,
  handleNameInput: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleNameSelect: PropTypes.func,
  nameSuggestions: PropTypes.arrayOf(PropTypes.object),
  visibility: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.object),
  createTagRequestPending: PropTypes.bool,
  deleteTagRequestPending: PropTypes.string,
  dropdownLoading: PropTypes.bool,
  tagName: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
  tagValue: PropTypes.string,
};

AssetTagDisplay.defaultProps = {
  tags: [],
};
